import React from 'react';
import { ProgressionShowcase } from '../../components/progression';

const ProgressionPreview: React.FC = () => {
  return <ProgressionShowcase />;
};

export default ProgressionPreview;
